module.exports = "/assets/images/04aa73f630eba3c2492a68dd3ec69089.jpg";